<template>
  <div id="app">
    <div id="nav-empresa-seleccionada">
      <EmpresaSeleccionada @empresaSeleccionada="obtenerEmpresa" />
    </div>
    <div id="nav">
      <Navbar />
    </div>
    <div id="contenedor" :class="{
        'm-select-company': empresaSeleccionada
      }">
      <router-view />
    </div>
    <!--<AvisoCookies />
    <NotificacionesPush />-->
    <Footer :empresaSeleccionada="empresaSeleccionada" />
    <FlechaSubir />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar/Navbar.vue";
import Footer from "@/components/Footer/Footer.vue";
import AvisoCookies from "@/components/AvisoCookies";
import Vue from "vue";
import loading from "vuejs-loading-screen";
import EmpresaSeleccionada from "@/components/Navbar/EmpresaSeleccionada.vue";
import FlechaSubir from "@/components/FlechaSubir.vue";
import NotificacionesPush from "./components/NotificacionesPush.vue";
Vue.use(loading, {
  bg: "rgba(0,0,0,0.5);",
  slot: `
    <div class="px-5 py-3 bg-gray-800 rounded">
      <h3 class="text-4xl text-light"><i class="fas fa-circle-notch fa-spin" style="font-size: 50pt"></i></h3>
    </div>
  `,
});
export default {
  components: {
    Navbar,
    Footer,
    AvisoCookies,
    EmpresaSeleccionada,
    FlechaSubir,
    NotificacionesPush
  },

  data() {
    return {
      empresaSeleccionada: null
    }
  },

  methods: {
    obtenerEmpresa(data) {
      this.empresaSeleccionada = data;
    },
  }
}
</script>

<style src="@/../public/css/colors.css" />

<style src="@/../public/css/navs.css" />

<style src="@/../public/css/forms.css" />

<style src="@/../public/css/buttons.css" />

<style src="@/../public/css/badge.css" />

<style src="@/../public/css/sweetalert2.css" />

<style>
/* TEMA CLARO */
@import url("https://fonts.googleapis.com/css2?family=Work+Sans:wght@200;400&display=swap");

*,
*:before,
*:after {
  box-sizing: border-box;
}

body {
  font-family: Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Work-sans", Helvetica, Arial, sans-serif;
  line-height: 1.5;
  background-color: #f3f3f3 !important;
  overflow-x: hidden;
  overflow-y: auto;
}

h1,
h2,
h3,
h4 {
  text-wrap: balance;
}

::selection {
  background: #6127ff;
  color: white;
}

::-moz-selection {
  background: #6127ff;
  color: white;
}

::-webkit-scrollbar-track {
  border-radius: 0px;
  background: #fff;
}

::-webkit-scrollbar-thumb {
  border-radius: 0px;
}

::-webkit-scrollbar-thumb:hover {
  border-radius: 0px;
}

::-webkit-scrollbar-corner {
  border-radius: 0px;
}

.v-toast {
  z-index: 20000 !important;
}

.dropdown-menu .dropdown-item:active {
  background-color: #6127ff;
}

.m-select-company {
  padding: 0px;
  margin-top: 50px;
}

/* TEMA OSCURO */
[data-bs-theme="dark"] body {
  background-color: #2f2f2f !important;
}

[data-bs-theme="dark"] ::-webkit-scrollbar-track {
  background-color: #3c3c44;
  border-radius: 0px;
}

[data-bs-theme="dark"] ::-webkit-scrollbar-track-piece {
  background: #343434;
  border-radius: 0px;
}

[data-bs-theme="dark"] ::-webkit-scrollbar-thumb {
  background-color: #5a5a5a;
  border-radius: 0px;
}

[data-bs-theme="dark"] ::-webkit-scrollbar-corner {
  background: #343434;
  border-radius: 0px;
}

[data-bs-theme="dark"] ::-webkit-resizer {
  background-color: #5a5a5a;
  border-radius: 0px;
}

[data-bs-theme="dark"] .modal-content,
[data-bs-theme="dark"] .offcanvas,
[data-bs-theme="dark"] .dropdown-menu {
  background: rgb(33, 33, 33) !important;
}
</style>